import { cn } from '../../cn';
import { NoSafariTruncationTip, Tooltip } from '../../ui/tooltip';
import { TypeTag } from './TypeTag';

const NOTE_COLOR = 'var(--destructive)';

/** Бейдж md (шапка карточки) — и в покое, и в правке заметки на месте */
export const NAME_NOTE_MD_CLASS =
  'nd:inline-flex nd:w-fit nd:max-w-full nd:items-center nd:rounded-[0.25rem] nd:bg-[color-mix(in_oklab,var(--destructive)_16%,transparent)] nd:px-2 nd:py-0.5 nd:text-xs nd:font-medium nd:text-[color-mix(in_oklab,var(--destructive)_85%,var(--foreground))]';

/**
 * Заметка к названию проекта (name_note) — красный квадратный бейдж, как тег типа файла (концепт compact-rows 1.2.2.1).
 * md — шапка карточки: длинная заметка переносится; sm — строка списка: высотой с бейдж подстатуса, длинная обрезается.
 */
export function NameNote({ note, size, className }: { note: string; size: 'sm' | 'md'; className?: string }) {
  if (size === 'sm') {
    return (
      <Tooltip label={note} truncated>
        <TypeTag color={NOTE_COLOR} className={cn('nd:min-w-0 nd:shrink nd:overflow-hidden', className)}>
          <span className="nd:truncate">
            {note}
            <NoSafariTruncationTip />
          </span>
        </TypeTag>
      </Tooltip>
    );
  }
  return <span className={cn(NAME_NOTE_MD_CLASS, className)}>{note}</span>;
}
